import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { StepProps } from '../../Step'
import { FooterBar } from './FooterBar'
import { FieldErrorGate } from './FieldErrorGate'

type Props = {
  stepProps: StepProps[]
  setCurrentStepIndex: React.Dispatch<React.SetStateAction<number>>
  currentStepIndex: number
  /** Optional — when paired with `step.fields`, the footer auto-gates
   *  Next on rhf errors for those fields and runs `form.trigger` on
   *  the click. Most steps should compute `disabled` themselves. */
  form?: UseFormReturn<any>
}

/** Routes to the form-aware footer only when a real form is supplied, so
 *  the common no-form path mounts no react-hook-form hooks at all. The
 *  branch keys off `form` (stable per Stepper) — never the per-step
 *  fields — so the footer never remounts mid-flow. */
export const StepperFooter = ({ stepProps, ...props }: Props) => {
  const selectedStep = stepProps[props.currentStepIndex]
  const renderBar = (fieldsHaveErrors: boolean) => (
    <FooterBar
      stepProps={stepProps}
      {...props}
      fieldsHaveErrors={fieldsHaveErrors}
    />
  )

  return props.form ? (
    <FieldErrorGate form={props.form} fields={selectedStep?.fields}>
      {renderBar}
    </FieldErrorGate>
  ) : (
    renderBar(false)
  )
}
